<div class="grid-container full-height full v-pad">
        <div class="grid-x grid-margin-x">
            <div class="user-form-max-width" [formGroup]="form">
                <div class="cell small-12 medium-12 large-12 italic">
                    Do not add unnecessary space before the content of the order.  Additional space will be added by the system to ensure there is sufficient room for the header for the first page.
                </div>
                <div class="cell small-12 medium-12 large-12">
                    <div formControlName="updatedContents" id="updatedContents" name="updatedContents" [froalaEditor]="froalaOptions"> </div>
                </div>
            </div>
        </div>
        <button class="next-link vertical-middle" (click)="saveLetter()" type="button">
            <span>Next</span>
            <span aria-hidden="true" class="next-link-span">
                <svg-icon icon="icon-chevron-right" class="white" aria-hidden="true"></svg-icon>
            </span>
        </button>
</div>
